module.exports = __webpack_public_path__ + "img/jdjbicon1.46426602.png";